/* SiteLoom sets important inline padding when it opens a submenu. */
(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  const selector = '.mobile-menu-panel .menu-column > ul.column-container';
  const lists = new Map();
  function apply(list) {
    const original = lists.get(list);
    for (const [property, value] of [['padding-top', '22px'], ['padding-left', '25px']]) {
      const wanted = desktop.matches ? [value, 'important'] : original[property];
      if (list.style.getPropertyValue(property) !== wanted[0] || list.style.getPropertyPriority(property) !== wanted[1]) {
        list.style.setProperty(property, wanted[0], wanted[1]);
      }
    }
  }
  function discover() {
    document.querySelectorAll(selector).forEach(list => {
      if (!lists.has(list)) {
        const original = {};
        ['padding-top', 'padding-left'].forEach(property => {
          original[property] = [list.style.getPropertyValue(property), list.style.getPropertyPriority(property)];
        });
        const observer = new MutationObserver(() => { if (desktop.matches) apply(list); });
        observer.observe(list, { attributes: true, attributeFilter: ['style'] });
        original.observer = observer;
        lists.set(list, original);
      }
      if (desktop.matches) apply(list);
    });
    lists.forEach((original, list) => {
      if (!list.isConnected) { original.observer.disconnect(); lists.delete(list); }
    });
  }
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true });
  desktop.addEventListener('change', () => lists.forEach((_, list) => apply(list)));
  discover();
})();
